<template>
  <DsShowcase title="IconGoogle" description="Wrapper para Material Symbols. Suporta os 3 tipos (outlined, rounded, sharp), tamanho, peso, fill e cor.">
    <!-- PROP: name -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">name</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — nome do ícone Material Symbols</p>
      <div class="tw:flex tw:items-center tw:gap-6 tw:flex-wrap">
        <div v-for="icon in sampleIcons" :key="icon" class="tw:flex tw:flex-col tw:items-center tw:gap-1">
          <IconGoogle :name="icon" size="28px" />
          <span class="tw:text-[10px] tw:opacity-50">{{ icon }}</span>
        </div>
      </div>
    </section>

    <!-- PROP: type -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">type</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'outlined' | 'rounded' | 'sharp'</code> — padrão: <code>outlined</code></p>
      <div class="tw:flex tw:items-center tw:gap-10 tw:flex-wrap">
        <div v-for="t in ['outlined', 'rounded', 'sharp'] as const" :key="t" class="tw:flex tw:flex-col tw:items-center tw:gap-2">
          <IconGoogle name="home" :type="t" size="36px" />
          <span class="tw:text-xs tw:opacity-60">{{ t }}</span>
        </div>
      </div>
    </section>

    <!-- PROP: size -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">size</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — CSS font-size. Padrão: <code>1.3rem</code></p>
      <div class="tw:flex tw:items-end tw:gap-6 tw:flex-wrap">
        <div v-for="s in ['14px', '20px', '28px', '36px', '48px', '64px']" :key="s" class="tw:flex tw:flex-col tw:items-center tw:gap-1">
          <IconGoogle name="star" :size="s" />
          <span class="tw:text-[10px] tw:opacity-50">{{ s }}</span>
        </div>
      </div>
    </section>

    <!-- PROP: fill -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">fill</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — ativa preenchimento do ícone. Padrão: <code>false</code></p>
      <div class="tw:flex tw:items-center tw:gap-8 tw:flex-wrap">
        <div v-for="icon in ['favorite', 'star', 'bookmark', 'check_circle', 'visibility']" :key="icon" class="tw:flex tw:flex-col tw:items-center tw:gap-3">
          <div class="tw:flex tw:gap-4">
            <IconGoogle :name="icon" size="32px" :fill="false" />
            <IconGoogle :name="icon" size="32px" :fill="true" />
          </div>
          <span class="tw:text-[10px] tw:opacity-50">{{ icon }}</span>
        </div>
      </div>
    </section>

    <!-- PROP: weight -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">weight</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>number</code> — 100 a 700. Padrão: <code>400</code></p>
      <div class="tw:flex tw:items-center tw:gap-6 tw:flex-wrap">
        <div v-for="w in [100, 200, 300, 400, 500, 600, 700]" :key="w" class="tw:flex tw:flex-col tw:items-center tw:gap-1">
          <IconGoogle name="settings" size="32px" :weight="w" />
          <span class="tw:text-[10px] tw:opacity-50">{{ w }}</span>
        </div>
      </div>
    </section>

    <!-- PROP: color -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">color</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — cor CSS. Padrão: <code>var(--fontcolor)</code></p>
      <div class="tw:flex tw:items-center tw:gap-6 tw:flex-wrap">
        <IconGoogle name="check_circle" size="32px" color="#38a169" :fill="true" />
        <IconGoogle name="error" size="32px" color="#e53e3e" :fill="true" />
        <IconGoogle name="warning" size="32px" color="#f59e0b" :fill="true" />
        <IconGoogle name="info" size="32px" color="#3182ce" :fill="true" />
        <IconGoogle name="pending" size="32px" color="#7c3aed" :fill="true" />
      </div>
    </section>

    <!-- PROP: grade -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">grade</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>number</code> — -50 a 200. Ajusta espessura do traço. Padrão: <code>0</code></p>
      <div class="tw:flex tw:items-center tw:gap-6 tw:flex-wrap">
        <div v-for="g in [-50, 0, 100, 200]" :key="g" class="tw:flex tw:flex-col tw:items-center tw:gap-1">
          <IconGoogle name="edit" size="32px" :grade="g" />
          <span class="tw:text-[10px] tw:opacity-50">{{ g }}</span>
        </div>
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import DsShowcase from '../DsShowcase.vue'
import { IconGoogle } from '@/components/atomic'

const sampleIcons = ['home', 'search', 'settings', 'person', 'favorite', 'star', 'add', 'delete', 'edit', 'close', 'check', 'arrow_forward', 'visibility', 'download', 'share']
</script>
